module.exports = __webpack_public_path__ + "04_face.2eaf2788.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/04_face.png
// module id = +pQy
// module chunks = 0